'use client'

//back-to-top
import { useEffect, useState } from "react";
import {
    CircleArrowUp
 }  from "lucide-react"

export default function BackToTop() {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 100) {
                setShow(true);
            } else {
                setShow(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const handleClick = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <div>
            {show && (
                <button
                    onClick={handleClick}
                    className="fixed bottom-4 right-4 bg-white p-2 rounded-full shadow-md"
                >
                    <CircleArrowUp size={24} />
                </button>
            )}
        </div>
    );
}